'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ui_container_plugin = require('clappr/src/base/ui_container_plugin');

var _ui_container_plugin2 = _interopRequireDefault(_ui_container_plugin);

var _events = require('clappr/src/base/events');

var _events2 = _interopRequireDefault(_events);

var _playback = require('clappr/src/base/playback');

var _playback2 = _interopRequireDefault(_playback);

require('./public/play_button.scss');

var _play = require('clappr/src/icons/01-play.svg');

var _play2 = _interopRequireDefault(_play);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlayButton = function (_UIContainerPlugin) {
  _inherits(PlayButton, _UIContainerPlugin);

  _createClass(PlayButton, [{
    key: 'name',
    get: function get() {
      return 'play_button';
    }
  }, {
    key: 'shouldRender',
    get: function get() {
      return this.container.playback.name !== 'html_img' && this.container.playback.getPlaybackType() !== _playback2.default.NO_OP;
    }
  }, {
    key: 'attributes',
    get: function get() {
      return {
        'data-play-button': ''
      };
    }
  }, {
    key: 'events',
    get: function get() {
      return {
        'click': 'clicked'
      };
    }
  }]);

  function PlayButton(container) {
    _classCallCheck(this, PlayButton);

    var _this = _possibleConstructorReturn(this, (PlayButton.__proto__ || Object.getPrototypeOf(PlayButton)).call(this, container));

    _this.hasStartedPlaying = false;
    _this.playRequested = false;
    _this.render();
    process.nextTick(function () {
      return _this.update();
    });
    return _this;
  }

  _createClass(PlayButton, [{
    key: 'bindEvents',
    value: function bindEvents() {
      this.listenTo(this.container, _events2.default.CONTAINER_STOP, this.onStop);
      this.listenTo(this.container, _events2.default.CONTAINER_PLAY, this.onPlay);
      this.listenTo(this.container, _events2.default.CONTAINER_STATE_BUFFERING, this.update);
      this.listenTo(this.container, _events2.default.CONTAINER_STATE_BUFFERFULL, this.update);
      this.listenTo(this.container, _events2.default.CONTAINER_OPTIONS_CHANGE, this.update);
    }
  }, {
    key: 'stopListening',
    value: function stopListening() {
      _get(PlayButton.prototype.__proto__ || Object.getPrototypeOf(PlayButton.prototype), 'stopListening', this).call(this);
    }
  }, {
    key: 'onPlay',
    value: function onPlay() {
      this.hasStartedPlaying = true;
      this.update();
    }
  }, {
    key: 'onStop',
    value: function onStop() {
      this.hasStartedPlaying = false;
      this.playRequested = false;
      this.update();
    }
  }, {
    key: 'showPlayButton',
    value: function showPlayButton(show) {
      if (show && (!this.options.chromeless || this.options.allowUserInteraction)) {
        this.$playButton.show();
        this.$el.addClass('clickable');
      } else {
        this.$playButton.hide();
        this.$el.removeClass('clickable');
      }
    }
  }, {
    key: 'clicked',
    value: function clicked() {
      if (!this.options.chromeless || this.options.allowUserInteraction) {
        this.playRequested = true;
        this.update();
        this.container.play();
      }
      return false;
    }
  }, {
    key: 'update',
    value: function update() {
      if (!this.shouldRender) {
        return;
      }
      var showPlayButton = !this.playRequested && !this.hasStartedPlaying && !this.container.buffering;
      this.showPlayButton(showPlayButton);
      if (!this.hasStartedPlaying) {
        this.container.disableMediaControl();
        this.$el.show();
      } else {
        this.container.enableMediaControl();
        this.$el.hide();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.shouldRender) {
        return;
      }
      this.$el.append(_play2.default);

      this.$playButton = this.$el.find('svg');
      this.container.$el.append(this.$el);

      var buttonsColor = this.options.mediacontrol && this.options.mediacontrol.buttons || '#ffffff';
      if (buttonsColor) {
        this.$el.find('svg path').css('fill', buttonsColor);
      }

      this.update();
      return this;
    }
  }]);

  return PlayButton;
}(_ui_container_plugin2.default);

exports.default = PlayButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/resources/js/player/overrides/clappr/plugins/play_button/play_button.js
// module id = 286
// module chunks = 0